export default __webpack_public_path__ + "static/media/Tu_billetera.04370ce9.svg";